import { useMutation } from '@tanstack/react-query';
import { createMealtime, ICreateMealtimeRequest } from 'src/api/createMealtime';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { IMealtime } from 'src/types/mealtimes.types';

export const useCreateMealtime = (menuId: string, setMealtimeId: (value: string) => void, onSuccess: () => void) => {
  const { showSnackbar } = useSnackbar();

  return useMutation(({ name, schedules }: ICreateMealtimeRequest) => createMealtime(menuId, { name, schedules }), {
    onSuccess: async (data: IMealtime) => {
      setMealtimeId(data.mealtime_id);
      onSuccess();
    },
    onError: () => {
      showSnackbar({
        message: 'Something went wrong whilst creating a mealtime',
        status: SnackbarStatus.ERROR,
      });
    },
  });
};
